<template>
  <v-dialog max-width="600px" v-model="dialogModel">
    <v-card>
      <v-card-title class="headline">
        <span>{{ $t('message.cancellationReason') }}</span>
      </v-card-title>
      <v-card-text>
        <v-layout row wrap>
          <v-flex>
            <v-form ref="form">
              <v-textarea
                solo
                v-model="reason"
                :error-messages="errors.collect('cancellationReason')"
                data-vv-name="cancellationReason"
                v-validate="'required|max:500'"
              ></v-textarea>
            </v-form>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn outline @click="onClose" color="error" small>{{ $t('message.close') }}</v-btn>
        <v-btn outline @click="onSave" color="primary" small>{{ $t('message.save') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: {
      required: true,
      default: false
    }
  },
  data() {
    return {
      dialogModel: this.dialog,
      reason: ""
    };
  },
  methods: {
    onClose() {
      this.reason = "";
      this.$emit("update:dialog", false);
      this.$validator.reset();
    },
    async onSave() {
      try {
        const valid = await this.$validator.validateAll();
        if (valid) {
          this.$emit("on-cancel", this.reason);
          this.$emit("update:dialog", false);
          this.$validator.reset();
        }
      } catch (error) {}
    }
  },
  watch: {
    dialog(value) {
      this.dialogModel = value;
    },
    dialogModel(value) {
      this.$emit("update:dialog", value);
    }
  }
};
</script>

<style>
</style>